module.exports = __webpack_public_path__ + "img/person-using-charger.e835f296.png";